import {
  ref,
  reactive,
  computed,
  onBeforeMount,
  getCurrentInstance,
  watch,
} from "@vue/composition-api";
import store from "@/store";
import router from "@/router";
import useModal from "@/@core/components/base-modal/hooks/useModal";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import { fufillmentDetailModel } from "@/models/fulfillment/fulfillment-detail";

export default function useShippingDetailModal(props) {
  const vm = getCurrentInstance().proxy;

  const { getFulfillmentDetail } = fufillmentDetailModel();

  const { openModal, closeModal } = useModal();
  const {
    openErrorModal,
    openSuccessModal,
    openWarningModal,
    openDefaultErrorModal,
  } = useValidationModal();

  const loadingType = reactive({
    onSearch: false,
    formData: false,
  });

  const formData = reactive({
    ticketId: 1,
    tranRef: null,
    rewardRef: null,
    reward: null,
    status: null,
    qty: null,
    pointTotal: null,
    rewardValue: null,
    issueDate: null,
    VoidedDate: null,
    txRef: null,
    remarkInfo: null,
    voidRef: null,
    voidRemark: null,
    itfRef: null,
    itfRef2: null,
    firstName: "",
    lastName: "",
    contactNo: "",
    address: null,
    houseNo: null,
    villageNo: null,
    buildingNo: null,
    street: null,
    lane: null,
    districtId: null,
    district: null,
    subDisrtrictId: null,
    subDisrtrict: null,
    postalCode: null,
    provinceId: null,
    province: null,
    remarkAddress: null,
    shippingId: null,
    fulfillmentRef: null,
    statusShipping: null,
    statusLabelTh: null,
    statusLabelEn: null,
    logisticValue: null,
    trackNo: null,
    trackUrl: null,
    detail: null,
    extraRef: null,
    extraRef2: null,

    previous : {
      district: "",
      subDistrict : "",
      province : ""
    }
  });

  const statusTracking = reactive({
    status:  2,
    dateIssue: "",
  });

  const optionData = reactive({
    statusOptions: [
      { label: "Not Specified", labelTh: "ไม่ระบุ", value: 0 },
      { label: "Pending", labelTh: "รอดำเนินการ", value: 1 },
      { label: "Preparing", labelTh: "กำลังเตรียม", value: 2 },
      { label: "Packed", labelTh: "บรรจุแล้ว", value: 5 },
      { label: "Shipped", labelTh: "จัดส่งแล้ว", value: 7 },
      { label: "Received", labelTh: "ได้รับแล้ว", value: 9 },
    ],
    logisticOptions: [
      { label: "DHL Express", value: 1 },
      { label: "Flash Express", value: 2 },
      { label: "Kerry Express", value: 3 },
      { label: "Thailand Post", value: 4 },
    ],
  });

  const fetchShippingData = () => {
    if (props.isEdit) fetchShippingDetail();
  };

  const fetchShippingDetail = () => {
    window.$loading(true)
    getFulfillmentDetail.payload.Ticket_Id = props.dataObj.selectId;

    store
      .dispatch("api/apiRequest", getFulfillmentDetail)
      .then((resp) => {
        const respDataFul = resp.data.resp.fulfillment;
        const respDataInfo = resp.data.resp.information;
      
        //shipping
        formData.ticketId = respDataFul.ticket_id;
        formData.fulfillmentRef = respDataFul.ffm_reference;
        formData.statusShipping = respDataFul.status;
        formData.statusLabelTh = respDataFul.status_desc;
        formData.statusLabelEn = respDataFul.status_desc;
        formData.logisticValue = respDataFul.shipping_company;
        formData.trackNo = respDataFul.tracking_no;
        formData.trackUrl = respDataFul.shipping_tracking_url;
        formData.detail = respDataFul.ffm_detail;
        formData.extraRef = respDataFul.extra_ref;
        formData.extraRef2 = respDataFul.extra_ref_2;

        //address
        formData.firstName = respDataFul.first_name;
        formData.lastName = respDataFul.last_name;
        formData.contactNo = respDataFul.contact_no
          ? String(respDataFul.contact_no).stringSymbolFormat("xxx-xxx-xxxx")
          : "";
        formData.address = respDataFul.address;
        formData.houseNo = respDataFul.house_no;
        formData.villageNo = respDataFul.village_no;
        formData.buildingNo = respDataFul.building;
        formData.street = respDataFul.street;
        formData.lane = respDataFul.lane;
        formData.district = respDataFul.district;
        formData.districtId = respDataFul.district_id
        formData.subDisrtrict = respDataFul.subdistrict;
        formData.subDisrtrictId = respDataFul.subdistrict_id;
        formData.postalCode = respDataFul.postalcode;
        formData.province = respDataFul.province;
        formData.provinceId = respDataFul.province_id;
        formData.remarkAddress = respDataFul.addr_remark;

        formData.previous.district = respDataFul.district;
        formData.previous.subDistrict = respDataFul.subdistrict;
        formData.previous.province = respDataFul.province;

        //information
        formData.tranRef = respDataInfo.txreference;
        formData.rewardRef = respDataInfo.privilege_alt_reference;
        formData.reward = respDataInfo.privilege_name_th;
        formData.status = respDataInfo.status;
        formData.qty = respDataInfo.amount;
        formData.pointTotal = `${respDataInfo.point_per_amount}/${respDataInfo.point_total}`;
        formData.rewardValue = respDataInfo.value_ref;
        formData.issueDate = respDataInfo.tx_time;
        formData.VoidedDate = respDataInfo.void_time;
        formData.txRef = respDataInfo.tx_ref;
        formData.voidRef = respDataInfo.void_ref;
        formData.voidRemark = respDataInfo.void_remark;
        formData.itfRef = respDataInfo.itf_ref;
        formData.itfRef2 = respDataInfo.itf_ref_2;

        statusTracking.status = respDataFul.status;
        statusTracking.dateIssue = respDataFul.updatedtime;

      })
      .catch((err) => {
        openDefaultErrorModal();
      })
      .finally(() => {
        window.$loading(false)
      })
  };

  const onInputNumber = (e) => {
    const num = e.replace(/\D/g, "").substring(0, 10);
    return num.stringSymbolFormat("xxx-xxx-xxxx");
  };

  const onSelectStatus = (statusId) => {
    const result = optionData.statusOptions.filter((o) => o.value === statusId);
    formData.statusLabelTh = result[0].label;
  };

  const onSearchTrackNo = () => {
    if (!formData.trackNo || loadingType.onSearch == true) return;

    loadingType.onSearch = true;

    setTimeout(() => {
      loadingType.onSearch = false;
    }, 5000);
  };

  const checkValidForm = () => {
    if (
      !formData.firstName ||
      !formData.lastName ||
      !formData.contactNo
    ) {
      openErrorModal('กรุณากรอกชื่อ นามสกุล และเบอร์โทรศัพท์',undefined,'กลับไปแก้ไข')
      return false;
    }
    return true;
  };

  const onSubmitModal = () => {
    if (!checkValidForm()) return;
    vm.$emit("onSubmit", formData, props.isEdit);
  };

  return {
    formData,
    optionData,
    loadingType,
    fetchShippingData,
    onSubmitModal,
    onInputNumber,
    onSelectStatus,
    onSearchTrackNo,
    statusTracking,
  };
}
